module.exports = __webpack_public_path__ + "img/assembling-machine-2-shadow.aa959d71.png";